import { useReviewsContext } from "@/components/Product/Reviews/context/reviews.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export const Count = () => {
    const { t } = useGranite();

    const { reviews, totalReviews } = useReviewsContext();

    return (
        <div>
            {totalReviews !== 0 &&
                t(
                    "product.reviews.filters.count",
                    reviews.length,
                    totalReviews
                )}
            {totalReviews === 0 &&
                t(
                    "product.reviews.filters.noReviews",
                    reviews.length,
                    totalReviews
                )}
        </div>
    );
};
